import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PixelService } from 'ngx-multi-pixel';

declare var fbq: any;
@Injectable({
  providedIn: 'root',
})
export class MetaPixelService {
  private platformId = inject(PLATFORM_ID);

  constructor(private pixel: PixelService) {}

  // Track page view
  trackPageView() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.pixel.track('PageView');
  }

  // fbclid
  captureFbclid() {
    if (!isPlatformBrowser(this.platformId)) return;

    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');

    if (fbclid) {
      const fbc = `fb.1.${Date.now()}.${fbclid}`;

      document.cookie = `_fbc=${fbc}; path=/; domain=.umrah-express.com; max-age=7776000; SameSite=Lax; Secure`;
    }
  }

  //-------------- Track specific standard actions example------------------------------
  track(
    event: 'AddToCart' | 'Purchase' | 'InitiateCheckout',
    value: number,
    currency: any,
    reservedRooms?: any[],
    packageName?: string|'package',
  ) {
    if (!isPlatformBrowser(this.platformId)) return;

    this.pixel.track(event, {
      value,
      currency,
      content_type: 'product',
      contents: reservedRooms?.map((r) => ({
        id: r?.priceDetailsId,
        quantity: r?.numberOfPassengers,
      })),

      content_name: packageName,
      content_ids: reservedRooms?.map((r) => r?.priceDetailsId),
    });
  }
}
